import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar, Doughnut } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import InputLabel from '@material-ui/core/InputLabel';

import SaveIcon from '@material-ui/icons/Save';
import ReactToPdf from 'react-to-pdf';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { get_agency_overview, get_agencies } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class ReportAgencyOverview extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(0, 99, 132, 0.6)", "rgba(99, 132, 0, 0.6)", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];

        this.ref = React.createRef();
        this.state = {
            csv_output: [],
            start_print: false,
            redraw: false,
            chartData: {},
            doughnuts: [],
            agencies: [],
            bar_options: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 5,
                            stepSize: 1
                        }
                    }]
                }

            },
            values: {
                agency: "",
                appointment_type: "all",
                date_from: (moment().subtract(7, 'days').format('YYYY-MM-DD')),
                date_to: moment().format("yyyy-MM-DD"),
            },
            rawReport: []
        };

        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let agencies = await get_agencies();
        if (agencies) {
            currentObj.setState({
                ...this.state,
                agencies: agencies,
                values: {
                    ...this.state.values,
                }
            }, () => {
                // this.get_data();
            });
        }
    }

    parse_chart_data(data) {
        var new_bar_options = {

        };
        var max_y_tick = 0;
        var labels = [];
        var doughnuts = [];
        var datasets = [{
            label: 'Appointment: No Show',
            stack: "stack1",
            backgroundColor: '#bdbdbd',
            borderColor: '#bdbdbd',
            borderWidth: 1,
            hoverBackgroundColor: '#bdbdbd',
            hoverBorderColor: '#bdbdbd',
            data: []
        }, {
            label: 'Appointment:  Arrived',
            stack: "stack1",
            backgroundColor: '#66bb6a',
            borderColor: '#66bb6a',
            borderWidth: 1,
            hoverBackgroundColor: '#66bb6a',
            hoverBorderColor: '#66bb6a',
            data: []
        }, {
            label: 'Appointment: Booked',
            stack: "stack1",
            backgroundColor: '#42a5f5',
            borderColor: '#42a5f5',
            borderWidth: 1,
            hoverBackgroundColor: '#42a5f5',
            hoverBorderColor: '#42a5f5',
            data: []
        },
        {
            label: 'Guests: No Show',
            stack: "stack2",
            backgroundColor: 'rgba(189, 189, 189, 0.56)',
            borderColor: 'rgba(189, 189, 189, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(189, 189, 189, 0.56)',
            hoverBorderColor: 'rgba(189, 189, 189, 0.56)',
            data: []
        },
        {
            label: 'Guests: Arrived',
            stack: "stack2",
            backgroundColor: 'rgba(102, 187, 106, 0.56)',
            borderColor: 'rgba(102, 187, 106, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(102, 187, 106, 0.56)',
            hoverBorderColor: 'rgba(102, 187, 106, 0.56)',
            data: []
        },
        {
            label: 'Guests: Booked',
            stack: "stack2",
            backgroundColor: 'rgba(66, 165, 245, 0.56)',
            borderColor: 'rgba(66, 165, 245, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(66, 165, 245, 0.56)',
            hoverBorderColor: 'rgba(66, 165, 245, 0.56)',
            data: []
        }
        ];
        for (var i = 0; i < data.length; i++) {
            var data_row = data[i];
            labels.push(data_row.short_name == "" ? data_row.name : data_row.short_name);

            datasets[0].data.push(data_row.data.no_show);
            datasets[1].data.push(data_row.data.arrived);
            datasets[2].data.push(data_row.data.total - data_row.data.no_show - data_row.data.arrived);
            datasets[3].data.push(data_row.data.no_show_pax);
            datasets[4].data.push(data_row.data.arrived_pax);
            datasets[5].data.push(data_row.data.total_pax - data_row.data.no_show_pax - data_row.data.arrived_pax);
            max_y_tick = max_y_tick > parseInt(data_row.data.total_pax) ? max_y_tick : parseInt(data_row.data.total_pax);
        }

        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets
            },
            rawReport: data,
            bar_options: {
                ...new_bar_options,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: max_y_tick + 5,
                            stepSize: 1
                        }
                    }]
                }
            }
        }, () => {
            this.downloadCSV();
        });

    }
    async get_data() {

        var data = await get_agency_overview({
            ...this.state.values,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD"),
            agency: this.state.values.agency,
        });
        if (data) {
            this.parse_chart_data(data.data);
        }
    }
    downloadCSV() {
        var export_data = [];
        var header = ['', 'Appt. Arrived', 'Appt. No Show', "Appt. Booked", "Appt. Total", "Guest Arrived", "Guest No Show", "Guest Booked", "Guest Total"];

        export_data.push(header);

        this.state.rawReport.map(row => {

            export_data.push([
                row.name,
                row.data.arrived,
                row.data.no_show,
                row.data.total - row.data.arrived - row.data.no_show,
                row.data.total,
                row.data.arrived_pax,
                row.data.no_show_pax,
                row.data.total_pax - row.data.arrived_pax - row.data.no_show_pax,
                row.data.total_pax
            ]);
        });
        this.setState({
            ...this.state,
            csv_output: export_data
        }, () => {
            console.log(this.state)
        }
        );
    }

    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Agency_By_Properties_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Agency_By_Properties_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Agency by Properties"
                            />
                            <Divider />
                            <CardContent class="report_container" className={useStyles.content}>
                                <div
                                    className="report_filter"
                                >
                                    <div className="filter_field_wrapper">
                                        <InputLabel shrink id="metric_label">
                                            Agency
                                        </InputLabel>
                                        <Select
                                            onChange={this.handleChange.bind(this)}
                                            name="agency"
                                            className="full_width"
                                            value={this.state.values.agency}
                                        >
                                            {
                                                this.state.agencies.map((agency) => (
                                                    <MenuItem key={agency.agency_id}
                                                        value={agency.agency_id}>
                                                        {agency.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <TextField
                                            type="date"
                                            name="date_from"
                                            label="From"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}

                                        />
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <TextField
                                            type="date"
                                            name="date_to"
                                            className="full_width"
                                            label="to"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>
                                    {/* <DatePicker
                                        format="dd/MM/y"
                                        onChange={date => this.setState({
                                            ...this.state,
                                            values: {
                                                ...this.state.values,
                                                date_from: date
                                            }
                                        }, () => {
                                            this.get_data();
                                        })}
                                        value={this.state.values.date_from}
                                        className="datepicker"
                                    ></DatePicker>
                                     <DatePicker
                                        format="dd/MM/y"
                                        onChange={date => this.setState({
                                            ...this.state,
                                            values: {
                                                ...this.state.values,
                                                date_to: date
                                            }
                                        }, () => {
                                            this.get_data();
                                        })}
                                        value={this.state.values.date_to}
                                        className="datepicker"
                                    ></DatePicker> */}


                                </div>
                                <div
                                    style={{
                                        width: this.state.start_print ? 900 : "auto"
                                    }}
                                    ref={this.ref}>
                                    {this.state.start_print && (
                                        <div style={{
                                            marginBottom: 30
                                        }}>
                                            <Grid container>
                                                <Grid item md={3}>
                                                    <img src={require("../../assets/logo_small.png")}></img>
                                                    <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                <Grid item md={6} style={{
                                                    textAlign: 'center'
                                                }}>
                                                    <h1>Agency By Properties</h1>
                                                </Grid>
                                            </Grid>


                                        </div>
                                    )}
                                    <div style={{
                                        height: '60vh',
                                        maxHeight: '20vh'
                                    }}>
                                        <Bar
                                            width={this.state.start_print ? 900 : 'auto'}
                                            options={{
                                                ...this.state.bar_options,
                                                maintainAspectRatio: false,
                                                devicePixelRatio: 3
                                            }}
                                            redraw={this.state.redraw}
                                            data={this.state.chartData}></Bar>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    {this.state.rawReport && (
                                        <React.Fragment>
                                            <Table className="report_table hide_mobile">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                            colSpan={4}>Appointments</TableCell>
                                                        <TableCell
                                                            style={{
                                                                textAlign: "center",
                                                                backgroundColor: "black",
                                                                color: "white"
                                                            }}
                                                            colSpan={4}>Guests</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                        >Arrived</TableCell>
                                                        <TableCell>No Show</TableCell>
                                                        <TableCell>Booked</TableCell>
                                                        <TableCell
                                                            className="bold"
                                                        >Total</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >Arrived</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >No Show</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >Booked</TableCell>
                                                        <TableCell
                                                            className="bold section_2"
                                                        >Total</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.name}</TableCell>
                                                            <TableCell>{row.data.arrived}</TableCell>
                                                            <TableCell>{row.data.no_show}</TableCell>
                                                            <TableCell>{row.data.total - row.data.arrived - row.data.no_show}</TableCell>
                                                            <TableCell className="bold">{row.data.total}</TableCell>
                                                            <TableCell className="section_2">{row.data.arrived_pax}</TableCell>
                                                            <TableCell className="section_2">{row.data.no_show_pax}</TableCell>
                                                            <TableCell className="section_2">{row.data.total_pax - row.data.arrived_pax - row.data.no_show_pax}</TableCell>
                                                            <TableCell className="section_2 bold">{row.data.total_pax}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>


                                            <Table className="report_table hide_desktop">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                            colSpan={4}>Appointments</TableCell>

                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>
                                                        <TableCell
                                                        >Arrived</TableCell>
                                                        <TableCell>No Show</TableCell>
                                                        <TableCell>Booked</TableCell>
                                                        <TableCell
                                                            className="bold"
                                                        >Total</TableCell>

                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.name}</TableCell>
                                                            <TableCell>{row.data.arrived}</TableCell>
                                                            <TableCell>{row.data.no_show}</TableCell>
                                                            <TableCell>{row.data.total - row.data.arrived - row.data.no_show}</TableCell>
                                                            <TableCell className="bold">{row.data.total}</TableCell>

                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                            <Table className="report_table hide_desktop">
                                                <TableHead>
                                                    <TableRow >
                                                        <TableCell style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}></TableCell>

                                                        <TableCell
                                                            style={{
                                                                textAlign: "center",
                                                                backgroundColor: "black",
                                                                color: "white"
                                                            }}
                                                            colSpan={4}>Guests</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell></TableCell>

                                                        <TableCell
                                                            className="section_2"
                                                        >Arrived</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >No Show</TableCell>
                                                        <TableCell
                                                            className="section_2"
                                                        >Booked</TableCell>
                                                        <TableCell
                                                            className="bold section_2"
                                                        >Total</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {this.state.rawReport.map((row) => (
                                                        <TableRow>
                                                            <TableCell className="bold">{row.name}</TableCell>
                                                            <TableCell className="section_2">{row.data.arrived_pax}</TableCell>
                                                            <TableCell className="section_2">{row.data.no_show_pax}</TableCell>
                                                            <TableCell className="section_2">{row.data.total_pax - row.data.arrived_pax - row.data.no_show_pax}</TableCell>
                                                            <TableCell className="section_2 bold">{row.data.total_pax}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </React.Fragment>


                                    )}
                                    <br></br>
                                    <br></br>

                                </div>

                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
